import {
    DataGrid,
    GridToolbarContainer,
} from '@mui/x-data-grid'; import React, { useState, useEffect } from 'react'
import { getClassName } from '../demat/Holdings';
import { Box, Typography } from '@material-ui/core';

const columns = [
    { field: 'strategy', headerName: 'Strategy', width: 120 },
    { field: 'alertsCount', headerName: 'Total alerts', width: 120, type: 'number' },
    { field: 'avgPnlPercentage', headerName: 'Avg P&L (%)', width: 120, type: 'number' },
    { field: 'maxPnlPercentage', headerName: 'Max P&L (%)', width: 120, type: 'number' },
    { field: 'minPnlPercentage', headerName: 'Min P&L (%)', width: 120, type: 'number' },
];

const StrategyPerformance = ({ user, fromDate, strategyPerformance, isLoading }) => {
    return (
        <Box
            sx={{
                '& .profit': {
                    color: 'green',
                },
                '& .loss': {
                    color: 'red',
                },
                '& .negative': {
                    backgroundColor: 'rgba(157, 255, 118, 0.49)',
                    color: '#1a3e72',
                    fontWeight: '600',
                },
                '& .positive': {
                    backgroundColor: '#d47483',
                    color: '#1a3e72',
                    fontWeight: '600',
                },
            }}
        >
            <DataGrid
                loading={isLoading}
                slots={{
                    toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
                        <Typography variant='h6' align='center'>Strategy Performance since {fromDate}</Typography>
                    </GridToolbarContainer>
                }}
                sx={{
                    boxShadow: 1,
                    border: 1,
                }}
                columns={columns}
                rows={strategyPerformance || []}
                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}
                pageSizeOptions={[10, 20, 30, 40]}
                autoHeight={true}
                getRowId={(row) => row.strategy}
                getCellClassName={(params) => {
                    if (params?.colDef?.type != 'number') return ''
                    // console.log(params);
                    return getClassName(params, params?.field)
                }}
            />
        </Box>
    )
}

export default StrategyPerformance